import { useMemo } from 'react';

import { CuroApplicationVariables } from 'enums/curo/Variables';
import { ICuroApplication } from 'types/curo/CuroApplication';

import { createOnlineConfig, createRefiConfig, createPPCConfig } from './SelectLoanOffer.config';
import { LoanOfferVariant } from './SelectLoanOffer.types';

interface IUseLoanOfferConfigProps {
  application: ICuroApplication;
  variant: LoanOfferVariant;
  onCancel?: () => void;
}


export const useLoanOfferConfig = ({
  variant,
  application,
  onCancel,
}: IUseLoanOfferConfigProps) => {
  const borrower = application.variables[CuroApplicationVariables.BorrowerFirstName] as string;

  return useMemo(() => {
    switch (variant) {
      case 'online':
        return createOnlineConfig(borrower);
      case 'refi':
        return createRefiConfig(borrower);
      case 'ppc':
        return createPPCConfig(onCancel);
    }
  }, [variant, borrower, onCancel]);
};
